<template>
    <div class="row">
        <footer-contact-information :contact-information-model="contactInformationModel" />
        <footer-link-list
            v-for="(linkColumn, index) in linksModel"
            :key="'link-columnn-' + index"
            :title="linksModel[index].ColumnTitleLink"
            :links-model="linksModel[index].ColumnLinks"
        />
    </div>
</template>

<script>
import FooterContactInformation from './FooterContactInformation.vue';
import FooterLinkList from './FooterLinkList.vue';

export default {
    name: 'FooterTopRow',
    components: {
        FooterContactInformation,
        FooterLinkList
    },
    props: {
        contactInformationModel: {
            type: Object,
            default() {
                return {};
            }
        },
        linksModel: {
            type: Array,
            default() {
                return [];
            }
        }
    }
};
</script>
